import React, { useMemo } from "react";
import objectPath from "object-path";
// LayoutContext

export function Layout({ children }) {

  return (<>
                  {children}
    </>);


}
